import { questionSummaryKey } from '@arnold/core';
import type { AnswerGroup, TextSource } from '../types';

export function nonEmptyTextRows(
  groups: AnswerGroup[],
  questionIndex: string,
  statementIndex?: number,
  source: TextSource = 'text',
): AnswerGroup[] {
  return groups.flatMap((group) => {
    const summary = group.questionSummaries.get(questionSummaryKey(questionIndex, statementIndex));
    const entries = source === 'comment' ? summary?.commentEntries : summary?.textEntries;
    return entries?.length
      ? [{ ...group, children: nonEmptyTextRows(group.children, questionIndex, statementIndex, source) }]
      : [];
  });
}

/** Visibility only: never rebuild a cohort or break apart an anonymous pool to hide empty rows. */
export function answeredRows(groups: AnswerGroup[], questionIndex: string, statementIndex?: number): AnswerGroup[] {
  return groups.flatMap((group) => {
    const summary = group.questionSummaries.get(questionSummaryKey(questionIndex, statementIndex));
    if (!summary?.respondingChannelIds.size) return [];
    return [{ ...group, children: answeredRows(group.children, questionIndex, statementIndex) }];
  });
}
